import React from "react";
import "./App.css";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Reveal from "./components/Reveal";
import { Hero, About } from "./components/Hero";
import { TrustBand } from "./components/Extras";
import { Services, Projects } from "./components/Showcase";
import { Process, WhyUs } from "./components/Process";
import { Contact, Footer } from "./components/Contact";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <Hero />
        <TrustBand />
        <Reveal><About /></Reveal>
        <Reveal><Services /></Reveal>
        <Reveal><Projects /></Reveal>
        <Reveal><Process /></Reveal>
        <Reveal><WhyUs /></Reveal>
        <Reveal><Contact /></Reveal>
      </main>
      <Footer />
    </div>
  );
}

export default App;
